
import { defineComponent, PropType } from 'vue'
import { Product } from '../../../types'
import VField from '../../base/form/VField.vue'
import VControl from '../../base/form/VControl.vue'


export default defineComponent({
  name: 'ProductSelect',
  components: {
    VField,
    VControl,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>
    },
    apiErrors: {
      type: Object as PropType<Record<string, any>>
    },
    value: {
      type: Number
    }
  },
  emits:['update'],
  computed: {
    splitProducts(): Record<string, any> {
      const results: Record<string, any> = {};
      if (!this.products) return {};

      this.products.forEach((product) => {
        if (product.product_spec._type === 'Comdty' &&
            product.product_spec.is_spread === false &&
            product.product_spec.split === true) {
          const key = product.product_spec.base_name;
          const nestedKey = product.name.replace(key, '');
          if (!(key in results)) {
            results[key] = {
              isNested: true,
              children: {}
            };
          }
          results[key].children[nestedKey] = product;
        } else {
          results[product.name] = {...product, isNested: false};
        }
      });

      // Sort children after all have been added
      Object.keys(results).forEach(key => {
        if (results[key].isNested) {
          results[key].children = this.sortNestedProducts(results[key].children);
        }
      });

      const sortedResults = this.sortProducts(results);

      return sortedResults
    },
    selectedProduct (): string {
      if (this.products) {
        const [ product, ...tail ] = this.products.filter((product) => {
          return product.id === this.value
        })
        if (product) {
          if ((product.product_spec._type === 'Comdty') && (product.product_spec.split===true))  {
            return product.product_spec.base_name
          } else {
            return product.name
          }
        }
      }
      return ''
    },
    selectedExpiry (): string {
      if (this.products) {
        const [ product, ...tail ] = this.products.filter((product) => {
          return product.id === this.value
        })
        if (product) {
          if ((product.product_spec._type === 'Comdty') && (product.product_spec.split===true)) {
            return product.name.replace(product.product_spec.base_name, '')
          }
          else{
            return product.name.replace(product.name, '')
          }
        }
      }
      return ''
    }
  },
  methods: {
    updateProductSelect (event: Event) {
      const target = event.target as HTMLInputElement
      if (this.products) {
        if (target.value) {
          const [product, ...tail] = this.products.filter((product) => (product.name.startsWith(target.value) && (product.product_spec.is_spread === false)))
          if (product) {
            this.$emit('update', {
              value: product.id,
              name: 'product',
            })
          }
          else {

            const [product, ...tail] = this.products.filter((product) => (product.name===target.value) && (product.product_spec.is_spread === true))

            if (product) {
              this.$emit('update', {
                value: product.id,
                name: 'product',
              })
            }

          }}
        else {
          this.$emit('update', {
            value: 0,
            name: 'product',
          })
        }
      }
    },
    updateExpirySelect (event: Event) {
      const target = event.target as HTMLInputElement
      this.$emit('update', {
        value: +target.value,
        name: 'product',
      })
    },
    sortProducts(products: Record<string, any>): Record<string, any> {
      // Convert the object to an array for sorting, with better type handling
      const productsArray: Product[] = Object.entries(products).map(([key, value]) => {
        const { key: ignoredKey, ...rest } = value as Product;
        return {
          key,
          ...rest
        };
      });

      // Sort products by ord_s if present, else alphabetically by key for those with null ord_s
      productsArray.sort((a, b) => {
        if (a.ord_s === null && b.ord_s === null) {
          return a.key.localeCompare(b.key); // Sort alphabetically if both are null
        } else if (a.ord_s === null) {
          return 1; // Place a after b if a is null and b is not
        } else if (b.ord_s === null) {
          return -1; // Place a before b if b is null and a is not
        } else if (a.ord_s === b.ord_s) {
          return a.key.localeCompare(b.key); // If ord_s are equal, sort alphabetically by key
        }
        return a.ord_s - b.ord_s; // Normal numeric sort by ord_s
      });

      // Convert the array back to an object, omitting the temporary key from final objects
      return productsArray.reduce((acc, product) => {
        const { key, ...rest } = product;
        acc[key] = rest;
        return acc;
      }, {} as Record<string, any>);
    },
    sortNestedProducts(products: any) {
      const keys = Object.keys(products);
      console.log('Original keys:', keys);

      const sortedKeys = keys.sort((a, b) => {
        const splitA = a.match(/^(\D*)(\d*)$/);
        const splitB = b.match(/^(\D*)(\d*)$/);

        if (!splitA || !splitB) {
          console.log(`Comparing ${a} and ${b} as strings`);
          return a.localeCompare(b);
        }

        const prefixA = splitA[1];
        const yearA = parseInt(splitA[2], 10);
        const prefixB = splitB[1];
        const yearB = parseInt(splitB[2], 10);

        console.log(`Comparing ${a} (${prefixA}, ${yearA}) and ${b} (${prefixB}, ${yearB})`);

        // Compare by year (number) first, in ascending order
        if (yearA !== yearB) {
          console.log(`Sorting by year: ${yearA} - ${yearB} = ${yearA - yearB}`);
          return yearA - yearB;
        }

        // If the years (numbers) are equal, compare by the prefix (letter) in ascending order
        const prefixComparison = prefixA.localeCompare(prefixB);
        if (prefixComparison !== 0) {
          console.log(`Sorting by prefix: ${prefixComparison}`);
          return prefixComparison;
        }

        // If both prefix and year are equal, compare the full strings
        console.log(`Sorting by full string: ${a.localeCompare(b)}`);
        return a.localeCompare(b);
      });

      console.log('Sorted keys:', sortedKeys);

      return sortedKeys.reduce((acc: any, key: any) => {
        acc[key] = products[key];
        return acc;
      }, {});

    },
  }
})
